import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const EmployeeAppraisal = () => {
  const routes = all_routes;

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Employee Appraisal & Performance Management</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.apar.dashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">APAR</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-12 d-flex">
              <div className="card w-100 mb-4 shadow-sm border-0 rounded-4 overflow-hidden position-relative">
                <div className="card-body p-4">
                  <div className="d-flex align-items-start justify-content-between mb-4">
                    <div>
                      <h4 className="mb-2 fw-bold text-primary">APAR Download</h4>
                      <p className="text-muted fs-14 mb-0">
                        Access and download your Annual Performance Appraisal Reports securely.
                      </p>
                    </div>
                    <div className="avatar avatar-lg bg-primary-transparent rounded flex-shrink-0">
                      <i className="ti ti-file-download text-primary fs-24"></i>
                    </div>
                  </div>
                  
                  <Link to={routes.apar.download} className="btn btn-primary w-100 d-flex justify-content-center align-items-center py-2 rounded-3 fw-semibold">
                    Go to APAR Download <i className="ti ti-arrow-right ms-2 fs-16"></i>
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-12 d-flex">
              <div className="card w-100 mb-4 shadow-sm border-0 rounded-4 overflow-hidden position-relative">
                <div className="card-body p-4">
                  <div className="d-flex align-items-start justify-content-between mb-4">
                    <div>
                      <h4 className="mb-2 fw-bold text-success">Appraisal Documents</h4>
                      <p className="text-muted fs-14 mb-0">
                        View, filter, and inspect detailed appraisal documents, self-assessments, and ratings.
                      </p>
                    </div>
                    <div className="avatar avatar-lg bg-success-transparent rounded flex-shrink-0">
                      <i className="ti ti-file-description text-success fs-24"></i>
                    </div>
                  </div>
                  
                  <Link to={routes.apar.documents} className="btn btn-success text-white w-100 d-flex justify-content-center align-items-center py-2 rounded-3 fw-semibold">
                    Go to Appraisal Documents <i className="ti ti-arrow-right ms-2 fs-16"></i>
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-12 d-flex">
              <div className="card w-100 mb-4 shadow-sm border-0 rounded-4 overflow-hidden position-relative">
                <div className="card-body p-4">
                  <div className="d-flex align-items-start justify-content-between mb-4">
                    <div>
                      <h4 className="mb-2 fw-bold text-info">Team Status Display</h4>
                      <p className="text-muted fs-14 mb-0">
                        Monitor and track the APAR status and progress for your team members.
                      </p>
                    </div>
                    <div className="avatar avatar-lg bg-info-transparent rounded flex-shrink-0">
                      <i className="ti ti-users-group text-info fs-24"></i>
                    </div>
                  </div>
                  
                  <Link to={routes.apar.teamStatus} className="btn btn-info text-white w-100 d-flex justify-content-center align-items-center py-2 rounded-3 fw-semibold">
                    Go to Team Status <i className="ti ti-arrow-right ms-2 fs-16"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeAppraisal;
